import { Flex } from '@utilitywarehouse/hearth-react';
import { ReactElement } from 'react';

import { BreakdownItem } from '@components/BreakdownItem';

enum Topics {
  unemploymentAndIllnesss = 'unemploymentAndIllnesss',
  personalAccident = 'personalAccident',
}

const createDetailsList = (items: string[]): ReactElement => (
  <Flex spacing="md" direction="column" asChild>
    <ul className="incomeProtector__coverage__breakdown-list">
      {items.map((item) => (
        <BreakdownItem key={item}>{item}</BreakdownItem>
      ))}
    </ul>
  </Flex>
);

export const topics = [
  {
    id: Topics.unemploymentAndIllnesss,
    title: 'Unemployment & illness cover',
    details: createDetailsList([
      'The policy provides cover for 65% of your pre-tax monthly income (up to a maximum of £750) if you cannot work due to illness, injury or involuntary unemployment',
      'This benefit is paid to you directly',
      'The policy provides up to 6 monthly benefit payments for any one claim',
    ]),
  },
  {
    id: Topics.personalAccident,
    title: 'Personal accident cover',
    details: createDetailsList([
      'The policy provides a lump sum payment of up to £10,000 if you suffer bodily injury from an accident, accidental death, loss of limb, loss of sight or permanent total disablement',
      'Benefit is paid to you or your estate',
      'Up to £50 per day if you are admitted to hospital as an inpatient due an accident',
    ]),
  },
] as const;
